export const RESIZE_DELAY = 50
export const RESPONSIVE_WIDTH_BREAKPOINT = 1280
